import { C, themeColors } from "./colors.js";

/**
 * Stroke for a chrome icon that turns the action color while its panel is open (settings,
 * account, the navigation rail's sections). Dawn and dev keep their fixed accent.
 *
 * @param {string} theme
 * @param {boolean} open
 * @returns {string}
 */
export function toggleStroke(theme, open) {
  if (theme === "dusk") return themeColors(theme).accent;
  if (theme === "dev") return C.action;
  return open ? C.action : themeColors(theme).grayL;
}
